// ============================================
// FILE: /frontend/src/components/dashboard/QuickActions.jsx
// PURPOSE: Quick access action buttons
// UPDATED: Changed "WhatsApp Bulk Share" label to be generic
// ============================================

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { PlusCircle, BarChart3, ChevronDown, X, Share2 } from 'lucide-react';

export default function QuickActions() {
  console.log('🎨 [QuickActions] Rendering');
  
  const [isExpanded, setIsExpanded] = useState(false);

  const actions = [
    {
      icon: PlusCircle,
      label: 'Post New Ad',
      to: '/listings/create',
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      icon: BarChart3,
      label: 'My Listings',
      to: '/my-listings',
      color: 'bg-green-500 hover:bg-green-600'
    },
    {
      icon: Share2,
      label: 'Bulk Collage Generator',
      to: '/dashboard/whatsapp-tools',
      color: 'bg-emerald-600 hover:bg-emerald-700'
    },
    
   {
    icon: Share2,
    label: 'Facebook Collage',
    to: '/dashboard/facebook-tools',
    color: 'bg-blue-600 hover:bg-blue-700'
  }
];

  return (
    <Card>
      {/* Clickable Header */}
      <CardHeader 
        className="p-3 sm:p-4 md:p-6 cursor-pointer hover:bg-accent/50 transition-colors relative"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm sm:text-base md:text-lg">Quick Actions</CardTitle>
          {isExpanded ? (
            <X className="w-4 h-4 sm:w-5 sm:h-5 text-muted-foreground" />
          ) : (
            <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-muted-foreground" />
          )}
        </div>
      </CardHeader>

      {/* Collapsible Content */}
      {isExpanded && (
        <CardContent className="p-3 sm:p-4 md:p-6 pt-0">
          <div className="flex flex-col gap-2 sm:gap-3">
            {actions.map((action, index) => (
              <Link
                key={index}
                to={action.to}
                className={`${action.color} text-white p-3 sm:p-4 rounded-lg transition-all hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] flex items-center gap-2 sm:gap-3`}
              >
                <action.icon className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
                <span className="text-xs sm:text-sm font-medium truncate">{action.label}</span>
              </Link>
            ))}
          </div>
        </CardContent>
      )}
    </Card>
  );
}